export default {
  AVAILABLE: 'Available',
  SELECTED: 'Selected'
};